"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contact = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const contact_address_entity_1 = require("./contact-address.entity");
const qualification_experience_entity_1 = require("./qualification-experience.entity");
const professional_experience_entity_1 = require("./professional-experience.entity");
const contact_details_entity_1 = require("./contact-details.entity");
const tpa_contact_entity_1 = require("./tpa-contact.entity");
const insurer_contact_entity_1 = require("./insurer-contact.entity");
const company_contact_entity_1 = require("./company-contact.entity");
const look_up_entity_1 = require("./look-up.entity");
const contact_document_map_entity_1 = require("./contact-document-map.entity");
const contact_communication_details_entity_1 = require("./contact-communication-details.entity");
const user_1 = require("./user");
const city_entity_1 = require("../../../../service-lib/src/lib/entities/city.entity");
const broker_contact_entity_1 = require("../../../../service-lib/src/lib/entities/broker-contact.entity");
/**
 * Entity representing a contact.
 */
let Contact = class Contact {
    constructor(salutationLid, firstName, lastName, middleName, displayName, linkedInUrl, companyLocationId, companyBranchId, tagLid, contactTypeLid, department, designation, reportingToId, relationshipTypeLid, remarks, contactRecordTypeLid, createdBy, updatedBy, createdAt, updatedAt, statusLid, contactAddresses, qualificationExperiences, professionalExperiences, contactDetails, deletedAt) {
        this.salutationLid = salutationLid;
        this.firstName = firstName;
        this.lastName = lastName;
        this.middleName = middleName;
        this.displayName = displayName;
        this.linkedInUrl = linkedInUrl;
        this.companyLocationId = companyLocationId;
        this.companyBranchId = companyBranchId;
        this.tagLid = tagLid;
        this.contactTypeLid = contactTypeLid;
        this.department = department;
        this.designation = designation;
        this.reportingToId = reportingToId;
        this.relationshipTypeLid = relationshipTypeLid;
        this.remarks = remarks;
        this.contactRecordTypeLid = contactRecordTypeLid;
        this.statusLid = statusLid;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.contactAddresses = contactAddresses;
        this.qualificationExperiences = qualificationExperiences;
        this.professionalExperiences = professionalExperiences;
        this.contactDetails = contactDetails;
        this.deletedAt = deletedAt;
    }
};
exports.Contact = Contact;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Object)
], Contact.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "salutation_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Contact.prototype, "salutationLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "first_name", type: "varchar", length: 100, nullable: false }),
    tslib_1.__metadata("design:type", String)
], Contact.prototype, "firstName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "last_name", type: "varchar", length: 100, nullable: false }),
    tslib_1.__metadata("design:type", String)
], Contact.prototype, "lastName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "middle_name", type: "varchar", length: 100, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Contact.prototype, "middleName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "display_name",
        type: "varchar",
        length: 200,
        nullable: false,
    }),
    tslib_1.__metadata("design:type", String)
], Contact.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "linkedin_url", type: "text", nullable: false }),
    tslib_1.__metadata("design:type", String)
], Contact.prototype, "linkedInUrl", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_location_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Contact.prototype, "companyLocationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_branch_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Contact.prototype, "companyBranchId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "tag_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Contact.prototype, "tagLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "contact_type_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Contact.prototype, "contactTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "department", type: "varchar", nullable: true }),
    tslib_1.__metadata("design:type", String)
], Contact.prototype, "department", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "designation", type: "varchar", nullable: true }),
    tslib_1.__metadata("design:type", String)
], Contact.prototype, "designation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "reporting_to_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Contact.prototype, "reportingToId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], Contact.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Contact.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "relationship_type_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Contact.prototype, "relationshipTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], Contact.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], Contact.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Contact.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Contact.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "contact_record_type_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Contact.prototype, "contactRecordTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], Contact.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "contact_record_type_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], Contact.prototype, "contactRecordType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "salutation_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], Contact.prototype, "salutation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "tag_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], Contact.prototype, "tag", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "contact_type_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], Contact.prototype, "contactType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "status_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], Contact.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "relationship_type_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], Contact.prototype, "relationshipType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => user_1.User),
    (0, typeorm_1.JoinColumn)({ name: "created_by", referencedColumnName: "userId" }),
    tslib_1.__metadata("design:type", Object)
], Contact.prototype, "owner", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => city_entity_1.City),
    (0, typeorm_1.JoinColumn)({ name: "company_location_id", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], Contact.prototype, "companyLocation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => contact_address_entity_1.ContactAddress, (contactAddress) => contactAddress.contact, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Object)
], Contact.prototype, "contactAddresses", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => qualification_experience_entity_1.QualificationExperience, (qualificationExperience) => qualificationExperience.contact, { cascade: true }),
    tslib_1.__metadata("design:type", Object)
], Contact.prototype, "qualificationExperiences", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => professional_experience_entity_1.ProfessionalExperience, (professionalExperience) => professionalExperience.contact, { cascade: true }),
    tslib_1.__metadata("design:type", Object)
], Contact.prototype, "professionalExperiences", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => contact_details_entity_1.ContactDetails, (contactDetails) => contactDetails.contact, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Object)
], Contact.prototype, "contactDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => contact_communication_details_entity_1.ContactCommunicationDetails, (contactCommunicationDetails) => contactCommunicationDetails.contact, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], Contact.prototype, "communicationDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => company_contact_entity_1.CompanyContactMap, (companyContact) => companyContact.contact, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], Contact.prototype, "companyContactMaps", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => tpa_contact_entity_1.TpaContact, (tpaContact) => tpaContact.linkedContact, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Array)
], Contact.prototype, "tpaContacts", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => insurer_contact_entity_1.InsureContact, (insurerContact) => insurerContact.contact, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], Contact.prototype, "insurerContacts", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => broker_contact_entity_1.BrokerContact, (brokerContact) => brokerContact.contact, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Array)
], Contact.prototype, "brokerContacts", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => contact_document_map_entity_1.ContactDocMap, (contactDocMap) => contactDocMap.contact),
    tslib_1.__metadata("design:type", Array)
], Contact.prototype, "contactDocMaps", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => Contact, (contact) => contact.reportingContacts, {
        nullable: true,
    }),
    (0, typeorm_1.JoinColumn)({ name: "reporting_to_id" }),
    tslib_1.__metadata("design:type", Object)
], Contact.prototype, "reportingTo", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => Contact, (contact) => contact.reportingTo),
    tslib_1.__metadata("design:type", Array)
], Contact.prototype, "reportingContacts", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => Contact, (contact) => contact.assistant),
    tslib_1.__metadata("design:type", Array)
], Contact.prototype, "assistantContacts", void 0);
exports.Contact = Contact = tslib_1.__decorate([
    (0, typeorm_1.Entity)("contact"),
    tslib_1.__metadata("design:paramtypes", [Number, String, String, String, String, String, Number, Number, Number, Number, String, String, Number, Number, String, Number, Number, Number, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, Number, Object, Object, Object, Object, typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object])
], Contact);
